module.exports = __webpack_public_path__ + "media/images/ticket/to_next-31379c1e97f07f520f9b1e571e38953d.png";